// Business constants shared across the UI. Single source of truth.
export const BUSINESS = {
    name: "A1 Screening",
    siteUrl: "https://a1screening247.com",
    phone: "239-434-7306",
    phoneTel: "+12394347306",
    email: "info@a1screening247.com",
    // Temporary backup email kept during the email migration. NOT shown on
    // public marketing pages — surfaced only in admin tools (e.g.
    // Verification Checklist) so John has a fallback he can reference if
    // info@a1screening247.com mail flow ever has an issue.
    backupEmail: "a1screening247@gmail.com",
    hours: "7:00 AM – 5:00 PM",
    brandLine: "From pool cages to condos, we screen it all.",
    since: "1999",
    primaryCity: "Naples, FL",
    secondaryCities: ["Fort Myers", "Cape Coral", "Lehigh Acres", "Bonita Springs"],
};

export const TRUST_PILLS = [
    "Family-Owned Since 1999",
    "Free Estimates",
    "Naples-Based",
    "Clean Workmanship",
    "26+ Years SWFL Experience",
];

export const USP_PILLARS = [
    { title: "Naples-First", body: "Naples is our home base, not an afterthought." },
    { title: "Free Estimates", body: "Every quote is free. No pressure." },
    { title: "Fast Turnaround", body: "We move quickly when you call." },
    { title: "Clean Workmanship", body: "Tight screens, neat frames, no mess left behind." },
    { title: "Reliable Communication", body: "We answer the phone and follow through." },
    { title: "26+ Years SWFL Experience", body: "Family-owned since 1999." },
];

export const PHASE3_BRAND_VOICE = {
    positioning:
        "Naples' trusted pool cage repair and rescreening team — family-owned and serving Southwest Florida since 1999.",
    cautious_storm:
        "Storm repair availability may vary by schedule and season.",
    // Public-facing wording shown on the photo upload form. Internal field
    // names like `requires_human_review` remain unchanged for schema stability;
    // only the customer-visible copy uses "technician review".
    photo_human_review:
        "Photos help the A1 Screening team understand the project before follow-up. Final recommendations and pricing are confirmed after technician review.",
    photo_helpful_use:
        "Photo uploads may help the team identify whether the request looks like a panel repair, door repair, storm damage, lanai screen issue, or possible rescreening project. Some issues may require an in-person look before final pricing.",
};
